// removed by extract-text-webpack-plugin
module.exports = {"title":"contactDealerSidebar__title__8557420","button":"contactDealerSidebar__button__8557420"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/ContactDealer/contactDealerSidebar.scss
// module id = 3440
// module chunks = 7